import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  CssBaseline,
  Dialog,
  Grid,
  IconButton,
  makeStyles,
  TextField,
  // TextareaAutosize,
  // Typography,
} from '@material-ui/core';
import { BarChart, Create, Delete } from '@material-ui/icons';
import SaveIcon from '@material-ui/icons/Save';
import MUIDataTable from 'mui-datatables';
import swal from '@sweetalert/with-react';
import moment from 'moment';
import axiosInstance, {
  addComma,
  // BCC_ADDR_EMAIL,
  BCC_ADDR_EMAIL_REG,
  EVENT_ID,
  F_EMAIL,
  getEventId,
  PAYCOMPLETE_TEMPLATE,
  saveDeadline,
  WEB_API,
} from '../constatns';
import AdminTopbar from './AdminTopbar';
import Popout from 'react-popout-new';
import AdminFooter from './AdminFooter';
import TableToolBarCustom from '../components/MuiDataTableCustom/TableToolBarCustom';
import TableFilterList from '../components/MuiDataTableCustom/TableFilterList';
import RegistrationSubmissionForm from '../registration/RegistrationSubmissionForm';
import { GiNotebook } from 'react-icons/gi';
import RegMemo from './RegMemo';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
  },
}));

const RegListPage = (props) => {
  const { history } = props;
  const classes = useStyles();
  const [data, setData] = useState();
  const [alldata, setAllData] = useState();
  const [selUser, setSelUser] = useState();
  const [selectFilter, setSelectFilter] = useState('all');
  const [open, setOpen] = useState(false);
  const [openUrl, setOpenUrl] = useState('');
  const [openMod, setOpenMod] = useState(false);
  const [selectData, setSelectData] = useState();
  const EVT = JSON.parse(sessionStorage.getItem('EVENT'));
  const [deadline, setDeadline] = useState(EVT && EVT.regDeadline ? EVT.regDeadline : moment().format('YYYY-MM-DDTHH:mm').toString());
  const [deadline2, setDeadline2] = useState(EVT && EVT.regDeadline2 ? EVT.regDeadline2 : moment().format('YYYY-MM-DDTHH:mm').toString());
  const [openMemo, setOpenMemo] = useState(false);

  let cols = [
    {
      name: 'id',
      label: 'No',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return tableMeta.tableData.length - tableMeta.rowIndex;
        },
      },
    },
    {
      name: 'regType',
      label: '등록구분',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value === 'R1' ? 'Early' : value === 'R2' ? 'Last' : 'On-site';
        },
      },
    },

    {
      name: 'regNo',
      label: 'RegNum',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'id',
      label: 'Email/ID',
      options: {
        filter: false,
        sort: true,
        download: false,
        display: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value.replace(EVENT_ID + '_', '');
        },
      },
    },
    {
      name: 'email',
      label: 'Email',
      options: {
        filter: true,
        sort: false,
        download: true,
      },
    },
    // {
    //   name: 'isKMA',
    //   label: '의사회 회원여부',
    //   options: {
    //     filter: false,
    //     sort: true,
    //     viewColumns: false,
    //   },
    // },
    {
      name: 'username',
      label: 'Name(KOR)',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        // display: false,
      },
    },
    {
      name: 'in_name_en',
      label: 'Name(ENG)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        // download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {value}
              {/* <div>{'(' + tableMeta.currentTableData[tableMeta.rowIndex].data[tableMeta.columnIndex - 1] + ')'}</div> */}
              {/* <div>{'(' + data[tableMeta.rowIndex].username + ')'}</div> */}
            </div>
          );
        },
      },
    },
    {
      name: 'country',
      label: 'Country',
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'position',
      label: 'Affiliation(KOR)',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        // display: false,
      },
    },
    {
      name: 'positionEn',
      label: 'Affiliation(ENG)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        // download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {value}
              {/* <div>{'(' + tableMeta.currentTableData[tableMeta.rowIndex].data[tableMeta.columnIndex + 1] + ')'}</div> */}
              {/* <div>{'(' + data[tableMeta.rowIndex].position + ')'}</div> */}
            </div>
          );
        },
      },
    },
    {
      name: 'license',
      label: '면허번호',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'cate1',
      label: 'Category',
      options: {
        filter: true,
        sort: false,
        // download: false,
        // download: false,
        // customBodyRender: (value, tableMeta, updateValue) => {
        //   return value;
        // },
      },
    },
    {
      name: 'cate2',
      label: '년차',
      options: {
        filter: false,
        sort: false,
        display: false,
        download: false,
      },
    },
    {
      // name: 'amount',
      name: 'id',
      label: '등록비',
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const item = data.find((f) => f.id === value);
          const regexp = /\B(?=(\d{3})+(?!\d))/g;
          // const prefix = data[tableMeta.rowIndex].lang === 'kor' ? 'KRW' : 'USD';
          const prefix = item.lang === 'kor' ? 'KRW' : 'USD';
          // return prefix + (' ' + value).replace(regexp, ',');
          return prefix + (' ' + item.amount).replace(regexp, ',');
        },
      },
    },
    {
      name: 'amount',
      label: '등록비 정렬',
      options: {
        filter: false,
        sort: true,
        // download: false,
        // customBodyRender: (value, tableMeta, updateValue) => {
        //   const item = data.find((f) => f.id === value);
        //   const regexp = /\B(?=(\d{3})+(?!\d))/g;
        //   // const prefix = data[tableMeta.rowIndex].lang === 'kor' ? 'KRW' : 'USD';
        //   const prefix = item.lang === 'kor' ? 'KRW' : 'USD';
        //   // return prefix + (' ' + value).replace(regexp, ',');
        //   return prefix + (' ' + item.amount).replace(regexp, ',');
        // },
      },
    },
    {
      name: 'regDate',
      label: '등록일',
      options: {
        filter: false,
        // sort: true,
        sort: false,
        display: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const dt = moment(Number(value));
          return dt.format('YYYY-MM-DD-HH:MM');
        },
      },
    },
    {
      // name: 'payCheckDate',
      name: 'id',
      label: '결제확인일',
      options: {
        filter: false,
        // sort: true,
        sort: false,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // 20220727
          // 결제확인일자 그대로 정렬되게
          // return value;
          // 20220728
          // 카드 결제는 payCheckDate 가 찍히는 구조가 아님, 적용 불가

          const item = data.find((f) => f.id === value);
          // const item = data[tableMeta.rowIndex];
          // const item = data_item.payCheckDate;

          let payAt = '';
          // 현재는 extraPayType 없음
          if (item.extraPayType) {
            if (item.extraPayType !== 'card' && item.payCheckDate) {
              payAt = item.payCheckDate;
            } else if (item.extraPayInfo) {
              if (item.lang === 'kor') {
                if (item.extraPayInfo.data) {
                  const dt = item.extraPayInfo.data.paymentInfo.approvalDate;
                  payAt =
                    dt.substr(0, 4) +
                    '-' +
                    dt.substr(4, 2) +
                    '-' +
                    dt.substr(6, 2) +
                    ' ' +
                    dt.substr(8, 2) +
                    ':' +
                    dt.substr(10, 2) +
                    ':' +
                    dt.substr(12, 2);
                } else {
                  payAt = '';
                }
              } else {
                if (item.extraPayInfo.resdt) {
                  payAt =
                    item.extraPayInfo.resdt.substr(0, 4) +
                    '-' +
                    item.extraPayInfo.resdt.substr(4, 2) +
                    '-' +
                    item.extraPayInfo.resdt.substr(6, 2) +
                    ' ' +
                    item.extraPayInfo.resdt.substr(8, 2) +
                    ':' +
                    item.extraPayInfo.resdt.substr(10, 2) +
                    ':' +
                    item.extraPayInfo.resdt.substr(12, 2);
                } else {
                  payAt = '';
                }
              }
            }
            if (item.extraPayType === 'bank' && item.extraStatus === 'Wait') payAt = '';
          } else {
            if (item.payCheckDate) {
              payAt = item.payCheckDate;
            } else if (item.payInfo) {
              // 신용카드 결제 국내
              if (item.lang === 'kor') {
                if (item.payInfo.data) {
                  const dt = item.payInfo.data.paymentInfo.approvalDate;
                  payAt =
                    dt.substr(0, 4) +
                    '-' +
                    dt.substr(4, 2) +
                    '-' +
                    dt.substr(6, 2) +
                    ' ' +
                    dt.substr(8, 2) +
                    ':' +
                    dt.substr(10, 2) +
                    ':' +
                    dt.substr(12, 2);
                } else {
                  payAt = '';
                }
              } else {
                // 신용카드 결제 해외
                if (item.payInfo.resdt) {
                  payAt =
                    item.payInfo.resdt.substr(0, 4) +
                    '-' +
                    item.payInfo.resdt.substr(4, 2) +
                    '-' +
                    item.payInfo.resdt.substr(6, 2) +
                    ' ' +
                    item.payInfo.resdt.substr(8, 2) +
                    ':' +
                    item.payInfo.resdt.substr(10, 2) +
                    ':' +
                    item.payInfo.resdt.substr(12, 2);
                } else {
                  payAt = '';
                }
              }
            }
            if (item.payType === 'bank' && item.status === 'Wait') payAt = '';
          }
          if (payAt.length < 2 && item.amount > 0) {
            payAt = item.payCheckDate;
          }
          return payAt;
        },
      },
    },

    //엑셀 다운로드 용
    {
      name: 'payCheckDate',
      // name: 'id',
      label: '결제확인일',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const item = data[tableMeta.rowIndex];

          let payAt = '';
          // 현재는 extraPayType 없음
          if (item.extraPayType) {
            if (item.extraPayType !== 'card' && item.payCheckDate) {
              payAt = item.payCheckDate;
            } else if (item.extraPayInfo) {
              if (item.lang === 'kor') {
                if (item.extraPayInfo.data) {
                  const dt = item.extraPayInfo.data.paymentInfo.approvalDate;
                  payAt =
                    dt.substr(0, 4) +
                    '-' +
                    dt.substr(4, 2) +
                    '-' +
                    dt.substr(6, 2) +
                    ' ' +
                    dt.substr(8, 2) +
                    ':' +
                    dt.substr(10, 2) +
                    ':' +
                    dt.substr(12, 2);
                } else {
                  payAt = '';
                }
              } else {
                if (item.extraPayInfo.resdt) {
                  payAt =
                    item.extraPayInfo.resdt.substr(0, 4) +
                    '-' +
                    item.extraPayInfo.resdt.substr(4, 2) +
                    '-' +
                    item.extraPayInfo.resdt.substr(6, 2) +
                    ' ' +
                    item.extraPayInfo.resdt.substr(8, 2) +
                    ':' +
                    item.extraPayInfo.resdt.substr(10, 2) +
                    ':' +
                    item.extraPayInfo.resdt.substr(12, 2);
                } else {
                  payAt = '';
                }
              }
            }
            if (item.extraPayType === 'bank' && item.extraStatus === 'Wait') payAt = '';
          } else {
            if (item.payCheckDate) {
              payAt = item.payCheckDate;
            } else if (item.payInfo) {
              // 신용카드 결제 국내
              if (item.lang === 'kor') {
                if (item.payInfo.data) {
                  const dt = item.payInfo.data.paymentInfo.approvalDate;
                  payAt =
                    dt.substr(0, 4) +
                    '-' +
                    dt.substr(4, 2) +
                    '-' +
                    dt.substr(6, 2) +
                    ' ' +
                    dt.substr(8, 2) +
                    ':' +
                    dt.substr(10, 2) +
                    ':' +
                    dt.substr(12, 2);
                } else {
                  payAt = '';
                }
              } else {
                // 신용카드 결제 해외
                if (item.payInfo.resdt) {
                  payAt =
                    item.payInfo.resdt.substr(0, 4) +
                    '-' +
                    item.payInfo.resdt.substr(4, 2) +
                    '-' +
                    item.payInfo.resdt.substr(6, 2) +
                    ' ' +
                    item.payInfo.resdt.substr(8, 2) +
                    ':' +
                    item.payInfo.resdt.substr(10, 2) +
                    ':' +
                    item.payInfo.resdt.substr(12, 2);
                } else {
                  payAt = '';
                }
              }
            }
            if (item.payType === 'bank' && item.status === 'Wait') payAt = '';
          }
          if (payAt.length < 2 && item.amount > 0) {
            payAt = item.payCheckDate;
          }
          return payAt;
        },
      },
    },

    // {
    //   name: 'id',
    //   label: '결제수단',
    //   options: {
    //     filter: true,
    //     sort: false,
    //     viewColumns: false,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       const item = data.find((f) => f.id === value);
    //       // const item = data[tableMeta.rowIndex];
    //       // console.log(item);
    //       return item.payType;
    //     },
    //   },
    // },
    {
      name: 'payType',
      label: '결제수단',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        download: true,
        // customBodyRender: (value, tableMeta, updateValue) => {
        //   const item = data[tableMeta.rowIndex];
        //   // console.log(item);

        //   if (item.isExtraCharge) {
        //     if (item.extraPayType) {
        //       return item.extraPayType;
        //     } else {
        //       return value;
        //     }
        //   } else {
        //     return value;
        //   }
        // },
      },
    },
    {
      name: 'status',
      label: '등록비 입금상태',
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
      },
    },
    {
      // name: 'status',
      name: 'id',
      label: '등록비 입금상태 수정',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const item = data.find((f) => f.id === value);
          return (
            <select value={item.status} onChange={(e) => handleStatus(e, value, updateValue, tableMeta)}>
              <option value={'Wait'}>Waiting for payment</option>
              <option value={'Complete'}>Completed</option>
            </select>
          );
        },
      },
    },

    {
      name: 'cate3',
      label: 'ICOPLAST ',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value) {
            return 'O';
          } else {
            return 'X';
          }
        },
      },
    },
    {
      name: 'cate4',
      label: 'APS',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value) {
            return 'O';
          } else {
            return 'X';
          }
        },
      },
    },

    {
      name: 'dinnerStatus',
      label: 'Gala Dinner 상태(정렬)',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'id',
      label: 'Gala Dinner 상태 (변경)',
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const item = data.find((f) => f.id === value);
          if (item.dinnerStatus) {
            return (
              <select value={item.dinnerStatus} onChange={(e) => handleStatusDinner(e, value, updateValue, tableMeta, item)}>
                <option value={'waiting'}>Waiting for payment</option>
                <option value={'complete'}>Completed</option>
              </select>
            );
          } else {
            return;
          }
        },
      },
    },
    {
      name: 'dinnerComp',
      label: '동반자 참석여부',
      options: {
        filter: false,
        sort: true,
      },
    },

    {
      name: 'compName',
      label: '동반자 성함',
      options: {
        filter: false,
        sort: false,
      },
    },

    {
      name: 'dinnerDepositor',
      label: 'Dinner 송금자명',
      options: {
        filter: false,
        sort: false,
      },
    },

    {
      name: 'dinnerDate',
      label: 'Dinner 결제요청일',
      options: {
        filter: false,
        sort: false,
      },
    },

    {
      name: 'isPaper',
      label: '초록접수여부',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? 'O' : 'X';
        },
      },
    },
    {
      name: 'isAbstract',
      label: 'Speaker Abstract 접수여부',
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? 'O' : 'X';
        },
      },
    },
    {
      name: 'id',
      label: '등록 Resend',
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const item = data.find((f) => f.id === value);
          return (
            <>
              {item.lang == 'kor' && (
                <Button
                  style={{ marginBottom: 5 }}
                  color={'primary'}
                  size={'small'}
                  variant={'contained'}
                  disableElevation
                  onClick={(e) => sendEmail(value, 'registrationKor')}
                >
                  등록완료메일(한글)
                </Button>
              )}
              {item.lang !== 'kor' && (
                <Button
                  style={{ marginBottom: 5 }}
                  color={'primary'}
                  size={'small'}
                  variant={'contained'}
                  disableElevation
                  onClick={(e) => sendEmail(value, 'registration')}
                >
                  등록완료메일(영문)
                </Button>
              )}
              <Button
                color={'primary'}
                size={'small'}
                variant={'contained'}
                disableElevation
                onClick={(e) => sendEmail(value, 'payComplete')}
              >
                결제완료메일(공통)
              </Button>
            </>
          );
        },
      },
    },

    {
      name: 'id',
      label: 'Dinner Resend',
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const item = data.find((f) => f.id === value);
          return (
            <>
              {item.dinnerStatus && (
                <Button
                  style={{ marginBottom: 5 }}
                  color={'primary'}
                  size={'small'}
                  variant={'contained'}
                  disableElevation
                  onClick={(e) => sendEmail(value, 'dinnerSubmit')}
                >
                  {item.lang == 'kor' ? '등록완료메일 재발송(한글)' : '등록완료메일 재발송(영문)'}
                </Button>
              )}

              {item.dinnerStatus && (
                <Button
                  // color={'primary'}
                  size={'small'}
                  variant={'contained'}
                  disableElevation
                  onClick={(e) => deleteDinnerData(value)}
                  style={{ backgroundColor: '#f00', color: '#fff', textTransform: 'none' }}
                >
                  Gala Dinner 신청 삭제
                </Button>
              )}
              {/* {item.dinnerStatus && item.dinnerStatus === 'complete' && (
                <Button
                  style={{ marginBottom: 5 }}
                  color={'primary'}
                  size={'small'}
                  variant={'contained'}
                  disableElevation
                  onClick={(e) => sendEmail(value, 'dinnerComplete')}
                >
                  12345
                  {item.lang == 'kor' ? '결제완료메일(한글)' : '결제완료메일(영문)'}
                </Button>
              )} */}
            </>
          );
        },
      },
    },
    // {
    //   name: 'attach',
    //   label: 'Document File',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value) => {
    //       return (
    //         <span onClick={(e) => handleDownload(value)} style={{ cursor: 'pointer' }}>
    //           <u>{value && value.replace(EVENT_ID + '_', '')}</u>
    //         </span>
    //       );
    //     },
    //   },
    // },
    {
      name: 'isExtraCharge',
      label: '추가결제자여부',
      options: {
        filter: true,
        sort: true,
        download: false,
        display: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? 'O' : 'X';
        },
      },
    },
    {
      name: 'id',
      label: '메모',
      options: {
        filter: false,
        sort: false,
        display: true,
        download: false,
        customBodyRender: (value) => {
          return (
            <div>
              <IconButton aria-label="memo" onClick={() => setUpdateMemo(value)}>
                <GiNotebook size={25} style={{ color: '#237a9d' }} />
              </IconButton>
            </div>
          );
        },
      },
    },
    {
      name: 'memo',
      label: '메모',
      options: {
        filter: false,
        sort: false,
        display: false,
        download: true,
      },
    },
    {
      name: 'id',
      label: '등록관리',
      options: {
        filter: false,
        sort: false,
        // sort: true,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <IconButton aria-label="update" onClick={() => setUpdateAction(value, tableMeta, updateValue)}>
                <Create fontSize="small" />
              </IconButton>
              {/* <IconButton aria-label="delete" onClick={() => setDeleteAction(tableMeta)}> */}
              <IconButton aria-label="delete" onClick={() => setDeleteAction(value)}>
                <Delete fontSize="small" />
              </IconButton>
            </div>
          );
        },
      },
    },
  ];

  // UAE Trainee 첨부파일 다운로드
  const handleDownload = (data) => {
    fetch(`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/attach/${data}`, { method: 'GET' })
      .then((res) => {
        return res.blob(); // raw 데이터를 받아온다
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob); // 받아온 날 상태의 data를 현재 window에서만 사용하는 url로 바꾼다
        const a = document.createElement('a');
        a.href = url;
        a.download = data; // 원하는 이름으로 파일명 지정
        document.body.appendChild(a);
        a.click(); // 자동으로 눌러버리기
        setTimeout((_) => {
          window.URL.revokeObjectURL(url); // 해당 url을 더 사용 못하게 날려버린다
        }, 60000);
        a.remove(); // a를 다 사용했으니 지워준다
      })
      .catch((err) => {
        console.error('err: ', err);
      });
  };

  const handleStatus = (e, value, updateValue, meta) => {
    // console.log(data[meta.rowIndex].id);
    // console.log(value);
    const _val = e.target.value;
    swal({
      title: '입금상태를 변경하시겠습니까?',
      text: '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        // console.log(_val);
        const updateStatus = {
          eventId: EVENT_ID,
          // userId: data[meta.rowIndex].id,
          userId: value,
          status: _val,
          payCheckDate: _val === 'Wait' ? '' : moment().format('YYYY-MM-DD HH:mm:ss'),
        };
        axiosInstance.put(`${WEB_API}/user/mod`, updateStatus).then((_result) => {
          // updateValue(_val);
          if (_val === 'Complete') {
            // 결제완료메일
            axiosInstance
              .post(
                `${WEB_API}/user/payCompleteEmail?evt=${EVENT_ID}&userId=${value}&templateName=${PAYCOMPLETE_TEMPLATE}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL_REG.toString()}`,
                //data[meta.rowIndex].id->value
              )
              .then((response) => {
                console.log(response, 'mail');
              });
          }
          getUserData();
        });
      }
    });
  };

  const handleStatusDinner = (e, value, updateValue, meta) => {
    const _val = e.target.value;
    console.log(_val);
    console.log(value, 'value');
    swal({
      title: 'Gala Dinner',
      text: '결제상태를 변경하시겠습니까?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const updateStatus = {
          evt: EVENT_ID,
          userId: value,
        };
        updateStatus['dinnerStatus'] = _val;
        // axiosInstance.put(`${WEB_API}/user/dinner`, updateStatus).then((_result) => {
        axiosInstance.put(`${WEB_API}/user/dinner`, updateStatus).then((_result) => {
          // updateValue(_val);

          if (_val === 'complete') {
            // 결제완료메일
            axiosInstance
              .post(
                `${WEB_API}/user/dinnerEmail?evt=${EVENT_ID}&userId=${value}&templateName=${'DinnerCompletePRS2022'}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL_REG.toString()}`,
              )
              .then((response) => {
                swal('Gala Dinner 결제 확인', '확인 메일이 발송되었습니다.', 'success');
              });
          }
          getUserData();
        });
      }
    });
  };

  const setUpdateAction = (val, meta, updateVal) => {
    const item = data.find((f) => f.id === val);
    if (selectFilter === 'deleted') {
      swal({
        title: '선택한 항목을 복구하시겠습니까?',
        text: '',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          const updateStatus = {
            eventId: EVENT_ID,
            // userId: data[meta.rowIndex].id,
            userId: item.id,
            isPay: 'R',
          };
          axiosInstance.put(`${WEB_API}/user/mod`, updateStatus).then((_result) => {
            setSelectFilter('all');
            getUserData();
          });
        }
      });
    } else {
      // const lang = meta.tableData[meta.rowIndex].country && meta.tableData[meta.rowIndex].country.indexOf('Korea') !== -1 ? 'kor' : 'eng';
      // setSelectData(data[meta.rowIndex]);
      setSelectData(item);
      if (openMod) {
        setOpenMod(false);
        setTimeout(function () {
          setOpenMod(true);
        }, 300);
      } else {
        setOpenMod(true);
      }
    }
  };

  const setUpdateMemo = (val, meta, updateVal) => {
    const item = data.find((f) => f.id === val);
    setSelectData(item);
    if (openMemo) {
      setOpenMemo(false);
      setTimeout(function () {
        setOpenMemo(true);
      }, 300);
    } else {
      setOpenMemo(true);
      console.log(item);
    }
  };

  // const setDeleteAction = (meta) => {
  const setDeleteAction = (val) => {
    const item = data.find((f) => f.id === val);
    swal({
      title: '정말 삭제하시겠습니까?',
      text: selectFilter === 'deleted' ? '삭제 후 복구할수 없습니다.' : '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        console.log(item);
        const updateStatus = {
          eventId: EVENT_ID,
          userId: item.id,
          isPay: selectFilter === 'deleted' ? 'P' : 'C',
        };
        if (selectFilter === 'deleted') {
          updateStatus['amount'] = 0;
          updateStatus['cate1'] = '';
          updateStatus['cate2'] = '';
          updateStatus['cate3'] = '';
          updateStatus['cate4'] = '';
          updateStatus['depositDate'] = '';
          updateStatus['depositor'] = '';
          updateStatus['payInfo'] = {};
          updateStatus['regNo'] = '';
          updateStatus['status'] = '';
        }
        axiosInstance.put(`${WEB_API}/user/mod`, updateStatus).then((_result) => {
          setSelectFilter('all');
          getUserData();
        });
      }
    });
  };

  const options = {
    print: false,
    filterType: 'dropdown',
    viewColumns: false,
    downloadOptions: {
      filename: `registration_${moment().valueOf()}.xls`,
    },
    searchOpen: true,
    selectableRows: 'none',
    customSearch: (searchQuery, currentRow, columns) => {
      let isFound = false;
      data.map((member) => {
        if (member.id === currentRow[0]) {
          for (const [key, value] of Object.entries(member)) {
            if (typeof value === 'string') {
              const val = value.toLowerCase().replace(/ /gi, '').replace(/-/gi, '').replace(/\+/gi, '');
              const search = searchQuery.toLowerCase().replace(/ /gi, '').replace(/-/gi, '').replace(/\+/gi, '');
              if (val.indexOf(search) !== -1) isFound = true;
            }
          }
        }
      });
      return isFound;
    },
    onDownload: (buildHead, buildBody, columns, downloadData) => {
      // console.log('download >>>>>');
      // console.log(data);
      const regDate = columns.findIndex((d) => d.name === 'regDate');
      const regType = columns.findIndex((d) => d.name === 'regType');
      const id = columns.findIndex((d) => d.label === 'ID');
      const cate1 = columns.findIndex((d) => d.name === 'cate1');
      const cate2 = columns.findIndex((d) => d.name === 'cate2');
      const cate3 = columns.findIndex((d) => d.name === 'cate3');
      const cate4 = columns.findIndex((d) => d.name === 'cate4');
      const amount = columns.findIndex((d) => d.name === 'amount');
      const isPaper = columns.findIndex((d) => d.name === 'isPaper');
      const isAbstract = columns.findIndex((d) => d.name === 'isAbstract');
      const payCheckDate = columns.findIndex((d) => d.name === 'payCheckDate');
      const payType = columns.findIndex((d) => d.name === 'payType');
      const country = columns.findIndex((d) => d.name === 'country');
      const position = columns.findIndex((d) => d.name === 'position');
      const positionEn = columns.findIndex((d) => d.name === 'positionEn');

      let retVal = [];
      downloadData.map((_d) => {
        const _info = data[_d.index];
        // console.log(_info, '_info'); //여기까지는 맞음
        if (regDate !== -1) {
          _d.data[regDate] = moment(Number(_d.data[regDate])).format('YYYY-MM-DD HH:mm');
        }
        if (regType !== -1) {
          _d.data[regType] = _d.data[regType] === 'R1' ? 'Early' : _d.data[regType] === 'R2' ? 'Last' : 'On-Site';
        }
        if (position !== -1) {
          _d.data[position] =
            _d.data[country].indexOf('Korea') !== -1 ? (_d.data[position] ? _d.data[position] : _d.data[positionEn]) : _d.data[positionEn];
        }
        // if (cate1 !== -1) {
        //   const user = data.find((u) => {
        //     return u.userId === _d.data[id];
        //   });
        //   if (user) {
        //     // _d.data[cate1] = `${user.cate1} ${user.cate2 ? '(' + user.cate2 + ')' : ''}`;
        //     _d.data[cate1] = `${user.cate1}`;
        //   }
        // }
        if (cate2 !== -1) {
          _d.data[cate2] = _d.data[cate2] ? _d.data[cate2].replace('전공의R', '') : '';
        }

        if (id !== -1) {
          _d.data[id] = _d.data[id].replace(EVENT_ID + '_', '');
        }
        if (cate3 !== -1) {
          _d.data[cate3] = _d.data[cate3] ? 'O' : 'X';
        }
        if (cate4 !== -1) {
          _d.data[cate4] = _d.data[cate4] ? 'O' : 'X';
        }
        if (amount !== -1) {
          //data[tableMeta.rowIndex].lang
          //_info
          _d.data[amount] = _d.data[amount]
            ? `${_info['lang'] === 'kor' ? 'KRW' : 'USD'} ${addComma(_d.data[amount])}`
            : `${_info['lang'] === 'kor' ? 'KRW' : 'USD'} 0`;
        }
        if (isPaper !== -1) {
          _d.data[isPaper] = _d.data[isPaper] ? 'O' : 'X';
        }
        if (isAbstract !== -1) {
          _d.data[isAbstract] = _d.data[isAbstract] ? 'O' : 'X';
        }
        if (payCheckDate !== -1) {
          // _d.data[payCheckDate] = _d.data[payCheckDate] ? 'O' : 'X';
          // _d.data[payCheckDate] = _d.data[payCheckDate];
          const item = _info;
          let payAt;
          if (item.extraPayType) {
            if (item.extraPayType !== 'card' && item.payCheckDate) {
              payAt = item.payCheckDate;
            } else if (item.extraPayInfo) {
              if (item.lang === 'kor') {
                if (item.extraPayInfo.data) {
                  const dt = item.extraPayInfo.data.paymentInfo.approvalDate;
                  payAt =
                    dt.substr(0, 4) +
                    '-' +
                    dt.substr(4, 2) +
                    '-' +
                    dt.substr(6, 2) +
                    ' ' +
                    dt.substr(8, 2) +
                    ':' +
                    dt.substr(10, 2) +
                    ':' +
                    dt.substr(12, 2);
                } else {
                  payAt = '';
                }
              } else {
                if (item.extraPayInfo.resdt) {
                  payAt =
                    item.extraPayInfo.resdt.substr(0, 4) +
                    '-' +
                    item.extraPayInfo.resdt.substr(4, 2) +
                    '-' +
                    item.extraPayInfo.resdt.substr(6, 2) +
                    ' ' +
                    item.extraPayInfo.resdt.substr(8, 2) +
                    ':' +
                    item.extraPayInfo.resdt.substr(10, 2) +
                    ':' +
                    item.extraPayInfo.resdt.substr(12, 2);
                } else {
                  payAt = '';
                }
              }
            }
            if (item.extraPayType === 'bank' && item.extraStatus === 'Wait') payAt = '';
          } else {
            if (item.payCheckDate) {
              payAt = item.payCheckDate;
            } else if (item.payInfo) {
              if (item.lang === 'kor') {
                if (item.payInfo.data) {
                  const dt = item.payInfo.data.paymentInfo.approvalDate;
                  payAt =
                    dt.substr(0, 4) +
                    '-' +
                    dt.substr(4, 2) +
                    '-' +
                    dt.substr(6, 2) +
                    ' ' +
                    dt.substr(8, 2) +
                    ':' +
                    dt.substr(10, 2) +
                    ':' +
                    dt.substr(12, 2);
                } else {
                  payAt = '';
                }
              } else {
                if (item.payInfo.resdt) {
                  payAt =
                    item.payInfo.resdt.substr(0, 4) +
                    '-' +
                    item.payInfo.resdt.substr(4, 2) +
                    '-' +
                    item.payInfo.resdt.substr(6, 2) +
                    ' ' +
                    item.payInfo.resdt.substr(8, 2) +
                    ':' +
                    item.payInfo.resdt.substr(10, 2) +
                    ':' +
                    item.payInfo.resdt.substr(12, 2);
                } else {
                  payAt = '';
                }
              }
            }
            if (item.payType === 'bank' && item.status === 'Wait') payAt = '';
          }
          if (payAt && payAt.length < 2 && item.amount > 0) {
            payAt = item.payCheckDate;
          }
          _d.data[payCheckDate] = payAt;
        }
        if (payType !== -1) {
          _d.data[payType] = _info['extraPayType'] ? _info['extraPayType'] : _d.data[payType];
        }
        retVal.push(_d);

        return _d;
      });
      // console.log(retVal, 'retVal');
      return '\uFEFF' + buildHead(columns) + buildBody(retVal);
    },
  };

  const getUserData = () => {
    console.log('getUserData >>>');
    axiosInstance
      .get(`${WEB_API}/user/list?eventId=${getEventId()}&reg=R&limit=-1`, { headers: { Pragma: 'no-cache' } })
      .then((response) => {
        const sortArr = response.data.Items.sort((a, b) => {
          if (a.regNo > b.regNo) return -1;
          if (a.regNo < b.regNo) return 1;
          return 0;
        });
        const sortArr2 = response.data.Items.sort((a, b) => {
          if (a.regDate > b.regDate) return -1;
          return 0;
        });
        setData(sortArr2);
        setAllData(sortArr2);
      });
  };
  useEffect(() => {
    getUserData();
  }, []);

  const doSaveDeadline = (no) => {
    if (no === 1) saveDeadline(deadline, 'regDeadline');
    else saveDeadline(deadline2, 'regDeadline2');
  };

  const handleClose = () => {
    console.log('Window Close');
    getUserData();
    setOpen(false);
    setOpenMod(false);
  };

  const handleCloseMemo = () => {
    console.log('memo Window Close');
    setOpenMemo(false);
    getUserData();
  };

  const handleFilter = (_filter) => {
    setSelectFilter(_filter);
    if (_filter === 'all') {
      setData(alldata);
    } else if (_filter === 'deleted') {
      //TODO deleted
      axiosInstance
        .get(`${WEB_API}/user/list?eventId=${getEventId()}&reg=C&limit=-1`, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          setData(response.data.Items);
        });
    } else {
      const newData = alldata.filter((d) => {
        return _filter === 'korean' ? d.country === 'Korea, Republic of' : d.country !== 'Korea, Republic of';
      });
      setData(newData);
    }
  };

  const sendEmail = (val, type) => {
    setOpenUrl(`/#/admin/Resend?type=${type}&id=${val}`);
    if (open) {
      setOpen(false);
      setTimeout(function () {
        setOpen(true);
      }, 300);
    } else {
      setOpen(true);
    }
  };

  const deleteDinnerData = (value) => {
    swal({
      title: 'Gala Dinner',
      text: 'Gala Dinner 신청을 삭제하시겠습니까?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const updateStatus = {
          eventId: EVENT_ID,
          userId: value,
        };
        updateStatus['compName'] = '';
        updateStatus['dinnerStatus'] = '';
        updateStatus['dinnerComp'] = '';
        updateStatus['dinnerDate'] = '';
        updateStatus['dinnerDepositor'] = '';
        axiosInstance.put(`${WEB_API}/user/mod`, updateStatus).then((_result) => {
          if (_result.status === 200) {
            swal('Gala Dinner', '정보가 삭제되었습니다.', 'success');
          }
          getUserData();
        });
      }
    });
  };

  return (
    <Grid item xs={12}>
      <CssBaseline />
      <AdminTopbar MIdx={5} SIdx={0} />
      <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
        <Grid item>
          <Grid container spacing={4} justifyContent={'flex-start'} alignItems={'center'}>
            <Grid item>
              <h1>Registration</h1>
            </Grid>
            <Grid item>
              <ButtonGroup color="primary" disableElevation>
                <Button variant={selectFilter === 'all' ? 'contained' : 'outlined'} onClick={() => handleFilter('all')}>
                  All Member
                </Button>
                <Button variant={selectFilter === 'korean' ? 'contained' : 'outlined'} onClick={() => handleFilter('korean')}>
                  Korean
                </Button>
                <Button variant={selectFilter === 'overseas' ? 'contained' : 'outlined'} onClick={() => handleFilter('overseas')}>
                  Overseas
                </Button>
                <Button variant={selectFilter === 'deleted' ? 'contained' : 'outlined'} onClick={() => handleFilter('deleted')}>
                  Deleted
                </Button>
              </ButtonGroup>
            </Grid>
            <Grid item>
              <Grid container alignItems={'center'} justifyContent={'center'}>
                <Grid item>
                  <TextField
                    style={{ marginRight: 5 }}
                    id="datetime-local"
                    label="1차 사전등록 마감 일시"
                    type="datetime-local"
                    defaultValue={deadline}
                    onChange={(e) => setDeadline(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item>
                  <Button
                    color="secondary"
                    variant={'outlined'}
                    startIcon={<SaveIcon />}
                    onClick={() => doSaveDeadline(1)}
                    disableElevation
                  >
                    저장
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid container alignItems={'center'} justifyContent={'center'}>
                <Grid item>
                  <TextField
                    style={{ marginRight: 5 }}
                    id="datetime-local"
                    label="2차 사전등록 마감 일시"
                    type="datetime-local"
                    defaultValue={deadline2}
                    onChange={(e) => setDeadline2(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item>
                  <Button
                    color="secondary"
                    variant={'outlined'}
                    startIcon={<SaveIcon />}
                    onClick={() => doSaveDeadline(2)}
                    disableElevation
                  >
                    저장
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item style={{ marginLeft: '100px' }}>
              <Button
                color="primary"
                variant={'outlined'}
                startIcon={<BarChart />}
                disableElevation
                onClick={() => history.push('/admin/registrationStatus')}
              >
                통계
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <MUIDataTable
            title={''}
            data={data}
            columns={cols}
            options={options}
            components={{ TableToolbar: TableToolBarCustom, TableFilterList: TableFilterList }}
          />
        </Grid>
      </Grid>
      <AdminFooter />
      {open ? <Popout url={openUrl} title="PRS2022-ADMIN" onClosing={handleClose} options={{ width: 1200, height: 800 }} /> : null}
      {openMod ? (
        <Dialog
          open={openMod}
          fullWidth
          maxWidth={'md'}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <RegistrationSubmissionForm
            mode={'modify'}
            userId={selectData.id}
            isPop={true}
            isAdmin={true}
            infoData={selectData}
            handleClose={handleClose}
          />
        </Dialog>
      ) : null}

      {openMemo ? (
        <Dialog
          open={openMemo}
          onClose={handleCloseMemo}
          fullWidth
          maxWidth={'sm'}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <RegMemo handleClose={handleCloseMemo} memoData={selectData.memo} userId={selectData.id} />
        </Dialog>
      ) : null}
    </Grid>
  );
};

export default RegListPage;
